import { writeSettingsFields } from './settings-fields';

/** `PATCH /client/settings/fields`: `settings.can_request_additional_driver`. */
export const editCanRequestAdditionalDriver = async (
  can_request_additional_driver: object
): Promise<any> => writeSettingsFields({ can_request_additional_driver });
